<template>
    <div class="news content-part">
         <div class="news-banner">
             <img src="https://0.rc.xiniu.com/g2/M00/0F/E3/CgAGfFwtrseAf-zYAAIK2n4N8fk359.jpg">
         </div>
         <div class="news-contain">
             <div class="n-main">
                 <ul class="new-header">
                     <li>公司新闻</li>
                     <li>行业新闻</li>
                     <li>媒体报道</li>
                 </ul>
                 <ul class="news-contain">
                     <li v-for="item in list" :key="item.id">
                         <div class="n-img">
                             <img :src="item.imgUrl">
                         </div>
                         <div class="n-content">
                             <p class="n-title">{{item.title}}</p>
                             <p class="n-date"><span>发布时间:</span><span>{{$moment(item.createDate).format('YYYY-MM-DD') }}</span></p>
                             <p class="n-cnt">{{item.outline}}</p>
                            <p class="n-detail">
                                <span @click="more(item.id)"></span>
                            </p>
                         </div>
                     </li>
                 </ul>
                 <div class="page">
                     <el-pagination
                       @current-change="getList"
                        :current-page="params.pageNo"
                        :page-size="params.size"
                        layout="prev, pager, next"
                        :total="totals">
                    </el-pagination>
                 </div>
             </div>
         </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            list:[],
            params:{
                pageNo:1,
                pageSize:8,
                type:''
            },
            totals:0,
        }
    },
    mounted(){
        this.getList()
    },
    methods:{
        getList(type){
            this.params.pageNo=type?type:1
            this.$http.get('/api/portal/news/queryPage',{
                params:this.params
            }).then((res)=>{
                this.list=res.data&&res.data.items?res.data.items:[]
                this.totals=res.data&&res.data.page&&res.data.page.rowCount?res.data.page.rowCount:0
            })
        },
        more(id){
            let url=window.location.protocol+'//'+window.location.host+'/newsView?id='+id
            window.open(url)
        }
    }
}
</script>

<style lang="less">
.news{
    .news-banner{
        width: 100%;
        height: 355px;
        img{
            width: 100%;
            height: 355px;
        }
    }
    .news-contain{
        .n-main{
            width: 1000px;
            margin: 0 auto;
            background: url(https://1.rc.xiniu.com/rc/Contents/4826/images/n_content_bg.png?d=20181101174910683) repeat-y;
            border: 1px solid rgb(233,233,233);
            .new-header{
                // width: 946px;
                height: 60px;
                padding: 50px 0 0 54px;
                margin-bottom: 5px;
                display: flex;
                >li{
                    width: 88px;
                    height: 26px;
                    margin-right: 4px;
                    font-size: 14px;
                    line-height: 26px;
                    text-align: center;
                    cursor: pointer;
                }
                li:hover{
                    background: rgba(1, 128, 255);
                    color: white;
                }
            }
            .news-contain{
                box-sizing: border-box;
                padding: 0 53px;
                margin-top: 20px;
                li{
                    display: flex;
                    height: 279px;
                    margin-bottom: 39px;
                    position: relative;
                    background: url(https://1.rc.xiniu.com/rc/Contents/4826/images/nnews_lb_m_bg.png?d=20181101174910683) 0 bottom no-repeat;
                    .n-img{
                        width: 345px;
                        height: 238px;
                        img{
                            width: 345px;
                            height: 238px;
                        }
                    }
                    .n-content{
                        width: 0;
                        flex: 1;
                        margin-left: 50px;
                    }
                    .n-title{
                        height: 34px;
                        line-height: 34px;
                        white-space: nowrap;
                        font-size: 24px;
                        text-overflow: ellipsis;
                        -o-text-overflow: ellipsis;
                        overflow: hidden;
                    }
                    .n-date{
                        height: 29px;
                        line-height: 29px;
                        font-size: 12px;
                        color: #999999;
                        margin-top: 30px;
                        span:first-child{
                            color: #999999;
                            margin-right: 5px;
                        }
                        span:last-child{
                            line-height: 29px;
                            font-size: 12px;
                            color: #999999;
                        }
                    }
                    .n-cnt{
                        width: 495px;
                        height: 72px;
                        overflow: hidden;
                        font-size: 14px;
                        line-height: 24px;
                        color: #666;
                        font-family: "宋体";
                    }
                    .n-detail{
                        display: flex;
                        justify-content: flex-end;
                        margin-top: 30px;
                        span{
                            color: #333;
                            width: 62px;
                            overflow: hidden;
                            height: 13px;
                            display: block;
                            text-decoration: none;
                            // font-size: 12px;
                            background: url(https://0.rc.xiniu.com/g2/M00/F1/15/CgAGfFvayZmAKfxxAABHLYzo0f4861.png) no-repeat;
                        }
                    }
                }
            }
            .page{
                text-align: center;
                box-sizing: border-box;
                padding: 50px 0 150px;
                .el-pagination{
                    display: inline-block;
                    .btn-prev,.btn-next{
                        background: transparent;
                        
                    }
                     .el-icon{
                         text-align: center !important;
                         font-size: 14px;
                     }
                     .el-pager{
                         >li{
                             border-radius: 50%;
                         }
                     }
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/view/news.vue